export default "__VITE_ASSET__8ed151c7__"